import { useFormikContext } from 'formik'
import { memo } from 'react'
import { useHistory } from 'react-router'

import AssignedItemsButton from 'components/AssignedItemsButton'
import Tooltip from 'components/Tooltip'

import { ReactComponent as PencilIcon } from 'assets/icons/IconPencil.svg'
import { ReactComponent as IconError } from 'assets/icons/IconError.svg'
import { hasMenuEmptyMerchantId } from 'utils/revenueCenters'

const MenusItem = memo(
  ({
    uuid,
    name,
    displayName,
    index,
    showValidationErrors,
    setShowValidationErrors,
    merchantId,
  }) => {
    const history = useHistory()
    const { values, errors } = useFormikContext()

    const assignedItemsLength =
      values?.assignedItemsToMenus?.find(
        (assignedItem) => assignedItem.menuUuid === uuid
      )?.assignedItemsUuids?.length ?? 0

    const handleClickAssignedItems = () => {
      setShowValidationErrors(false)

      history.push({
        state: {
          ...history.location.state,
          menuUuid: uuid,
          modalType: 'items',
        },
      })
    }

    const onClickEditMenu = (uuid) => {
      setShowValidationErrors(false)

      history.push({
        state: {
          ...history.location.state,
          menuUuid: uuid,
          modalType: 'menu',
          menuIndex: index,
          isNewMenu: false,
        },
      })
    }

    const isMenuError = hasMenuEmptyMerchantId(name, merchantId)

    return (
      <div
        className="service-type"
        key={uuid}
        data-cy={`service-type-${name}`}
      >
        <div className="service-type__describe">
          <div className="service-type__name">
            {name}: {displayName}
            {isMenuError && (
              <Tooltip text="Missing Merchant" relative>
                <span className="d-flex align-items-center padding-left-xsl">
                  <IconError />
                </span>
              </Tooltip>
            )}
          </div>
          <button
            className="service-type__pencil-icon"
            onClick={() => onClickEditMenu(uuid)}
          >
            <PencilIcon />
          </button>
        </div>
        <div className="content-wrapper">
          <AssignedItemsButton
            label="Select Items"
            handleClick={handleClickAssignedItems}
            assignedItems={assignedItemsLength}
            error={
              showValidationErrors &&
              errors?.assignedItemsToMenus?.[index]
            }
            dataCy={`assigned-items-button-${name}`}
          />
        </div>
      </div>
    )
  }
)

export default MenusItem
